import React from 'react';
import './about.css';

export default function About() {
  const googleDev = 'https://play.google.com/store/apps/dev?id=6150346668511112346';
  const appleDev = 'https://apps.apple.com/developer/ilia-stasik-sergey-ie/id93631479';

  return (
    <div className="about-page">
      <h1>About</h1>
      <p>
        My games are published under the following developer profiles:        
      </p>

      <ul>
        <li>Google Play - <a href={googleDev} target="_blank" rel="noreferrer">"Ilia Stasik Games"</a></li>
        <li>App Store - <a href={appleDev} target="_blank" rel="noreferrer">"ILIA STASIK SERGEY, IE"</a></li>
      </ul>

      <p>If you'd like to collaborate or ask about a project, contact me through the links above or via my social profiles or email</p>
      <p><a href="mailto:isstasik@gmail.com">isstasik@gmail.com</a></p>
      <p><a href="mailto:stasik.business@gmail.com">stasik.business@gmail.com</a></p>
    </div>
  );
}
